// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { SavedSpellAspect } from "src/api/spells";

import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Earth Wall",
  id: "earth-wall",
  metadata: {
    aspect: SavedSpellAspect.Earth,
    imports: ["earth", "self", "wait"],
    icon: {
      backgroundColor: 3022611,
      layers: [
        {
          iconKey: "earthSpike",
          position: {
            x: 0,
            y: 0
          },
          scale: 0.95,
          rotation: 0,
          color: 13474907
        },
        {
          iconKey: "delay",
          position: {
            x: 14,
            y: 3
          },
          scale: 0.6,
          rotation: -8,
          color: 16777215
        }
      ]
    }
  }
};

export default metadata;
